import { SchedulerExceptionForm } from "validation/components/EmailScheduler/exceptionsFormRules";
import { ActionType, createReducer } from "typesafe-actions";
import {
    cancelSchedulerRuleUpdate,
    createSchedulerRule,
    fetchSchedulerDefinitions,
    updateSchedulerRule,
} from "./definition.actions";
import { fetchSchedulerRuleExceptions } from "store/features/emailScheduler/exceptions";
import { copySchedulerRule, editSchedulerRule } from "store/features/emailScheduler/overview";
import { resetApiError } from "store/features/general";
import * as definitionActions from "./definition.actions";

type EmailSchedulerDefinitionAction = ActionType<typeof definitionActions>;

export type EmailSchedulerRuleDefinitionState = Readonly<{
    isProcessing: boolean;
    isSubmitted: boolean;
    hasError: boolean;
    // used only for edition
    properties: Readonly<{
        isEdited: boolean;
        isCopy: boolean;
        ruleId?: string;
    }>;
    templates: string[];
    deadlines: ReadonlyArray<{
        name: string;
        translation: string;
    }>;
    statuses: Array<{
        code: number;
        translation: string;
    }>;
    exceptions: SchedulerExceptionForm[];
}>;

export const emailSchedulerDefinitionInitialState: EmailSchedulerRuleDefinitionState = {
    isProcessing: false,
    isSubmitted: false,
    hasError: false,
    properties: {
        isCopy: false,
        isEdited: false,
    },
    templates: [],
    deadlines: [],
    statuses: [],
    exceptions: [],
};

export const emailSchedulerOverviewNewRuleReducer = createReducer<
    EmailSchedulerRuleDefinitionState,
    EmailSchedulerDefinitionAction
>(emailSchedulerDefinitionInitialState)
    .handleAction([fetchSchedulerDefinitions.request, fetchSchedulerRuleExceptions.request], (state) => {
        return {
            ...state,
            isProcessing: true,
            hasError: false,
            properties: state.properties,
        };
    })
    .handleAction(
        fetchSchedulerDefinitions.success,
        // ignore "fields" property at this point => it's stored in "filters"
        (state, { payload: { statuses, deadlines, templates, exceptions } }) => {
            return {
                ...state,
                isProcessing: false,
                templates: templates.map(({ name }) => name),
                deadlines,
                statuses,
                exceptions,
            };
        }
    )
    .handleAction(
        [fetchSchedulerDefinitions.failure, createSchedulerRule.failure, updateSchedulerRule.failure],
        (state) => {
            return {
                ...state,
                isSubmitted: false,
                isProcessing: false,
                hasError: true,
            };
        }
    )
    .handleAction([createSchedulerRule.request, updateSchedulerRule.request], (state) => {
        return {
            ...state,
            isProcessing: true,
        };
    })
    .handleAction([createSchedulerRule.success, updateSchedulerRule.success] as never, (state) => {
        return {
            ...state,
            isSubmitted: true,
            isProcessing: false,
        };
    })
    .handleAction(fetchSchedulerRuleExceptions.success, (state, { payload: { exceptions } }) => {
        return {
            ...state,
            isProcessing: false,
            exceptions,
        };
    })
    .handleAction([editSchedulerRule, copySchedulerRule], (state, { payload: { id, isCopy } }) => {
        return {
            ...state,
            properties: {
                isEdited: true,
                isCopy,
                ruleId: id,
            },
        };
    })
    .handleAction(cancelSchedulerRuleUpdate, (state) => {
        return {
            ...state,
            isSubmitted: false,
            properties: {
                isEdited: false,
                isCopy: false,
            },
        };
    })
    .handleAction(resetApiError as never, (state) => {
        return {
            ...state,
            hasError: false,
        };
    });
